module.exports = "https://cdn.dove.it/_next/static/public/assets/xmas.0edb59009f49327608eb0fde3d36ac99.png";